// extracted by mini-css-extract-plugin
module.exports = {"ModalBodyContent":"_3jUgreMJ"};